// The current application coordinates were pre-registered in a B2C tenant.
export const apiConfig = {
    b2cScopes: process.env.VUE_APP_B2C_SCOPES.split(',')
};